"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrCreateAssociatedTokenAccount = exports.getBalanceFromProvider = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const spl_token_1 = require("@solana/spl-token");
async function getBalanceFromProvider(provider, tokenAccount) {
    let info = await provider.connection.getAccountInfo(tokenAccount);
    if (info) {
        const account = spl_token_1.AccountLayout.decode(info.data);
        return new anchor.BN(account.amount, undefined, "le");
    }
    return new anchor.BN(0);
}
exports.getBalanceFromProvider = getBalanceFromProvider;
const getOrCreateAssociatedTokenAccount = async (provider, mint, walletKey) => {
    const associatedTokenAddress = await spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, walletKey);
    const associatedTokenAccountInfo = await provider.connection.getAccountInfo(associatedTokenAddress);
    if (associatedTokenAccountInfo != null) {
        return [associatedTokenAddress, []];
    }
    return [
        associatedTokenAddress,
        [
            spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, associatedTokenAddress, walletKey, walletKey),
        ],
    ];
};
exports.getOrCreateAssociatedTokenAccount = getOrCreateAssociatedTokenAccount;
